<!-- Table header, includes sorting button and master toggle checkbox -->
<mat-list *ngIf="dataRows?.length > 0">
  <mat-list-item>
    <h3
      matLine
      (click)="sortingMenuTrigger.openMenu()"
      data-cy="mobile-table-sorting-title"
      class="cursor-pointer mobile-table__sorting-title"
    >
      {{
        columnFromCurrentSort
          ? columnFromCurrentSort.header
            ? (columnFromCurrentSort.header | titlecase)
            : (columnFromCurrentSort.key | snakeCaseToHuman | titlecase)
          : 'Sort'
      }}
      <div style="margin-left: 0.5rem;" class="dropdown__icon--sort" *ngIf="columnFromCurrentSort?.key">
        <rav-icon
          class="mobile-table__sorting-direction-icon"
          [name]="currentSort?.direction !== 'asc' ? RavIcon.ArrowDownward : RavIcon.ArrowUpward"
        ></rav-icon>
      </div>
    </h3>
    <rav-icon
      data-cy="add-button"
      *ngIf="createAction && !isSelectingItems"
      matListIcon
      [name]="RavIcon.MobileAdd"
      (click)="addClick.emit(createAction?.name)"
      class="mobile-table__add-button cursor-pointer order-10"
    ></rav-icon>
    <rav-icon
      *ngIf="columnsToDisplay.includes('select') && !isSelectingItems"
      matListIcon
      [name]="RavIcon.MobileCheckbox"
      (click)="toggleIsSelectingItems($event)"
      data-cy="mobile-table-selection-enabler"
      class="mobile-table__options-icon order-11 cursor-pointer"
    ></rav-icon>
    <mat-checkbox
      *ngIf="columnsToDisplay.includes('select') && isSelectingItems"
      [checked]="masterToggleStatus === 'checked' && isSelectingItems"
      [indeterminate]="masterToggleStatus === 'indeterminate' && isSelectingItems"
      (click)="toggleIsSelectingItems($event)"
      data-cy="mobile-table-master-toggle"
      color="primary"
      class="mobile-table__toggle-checkbox order-11"
    ></mat-checkbox>
  </mat-list-item>
</mat-list>

<!-- Table sorting menu -->
<div #sortingMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="sortingMenu" style="position: fixed;">
  <mat-menu #sortingMenu="matMenu">
    <div class="grid-y">
      <div
        *ngFor="let column of config.columns"
        class="cell shrink"
        [class.mobile-table__sorting-button-active]="columnFromCurrentSort?.key === column.key"
      >
        <button
          *ngIf="this.shouldDisplaySortingOption(column)"
          class="flex-container align-middle padding-horizontal-1 mobile-table__sorting-button"
          (click)="emitSortUpdate(column.key)"
        >
          <div class="dropdown__icon--sort margin-right-1" *ngIf="columnFromCurrentSort?.key === column.key">
            <rav-icon
              [name]="currentSort?.direction !== 'asc' ? RavIcon.ArrowDownward : RavIcon.ArrowUpward"
            ></rav-icon>
          </div>
          <span
            data-cy="mobile-table-sorting-item"
            [ngStyle]="{ 'padding-left': columnFromCurrentSort?.key === column.key ? '0' : '2rem' }"
            >{{ column.header ? (column.header | titlecase) : (column.key | snakeCaseToHuman | titlecase) }}</span
          >
        </button>
      </div>
    </div>
  </mat-menu>
</div>

<!-- Simple item list with options button (ellipsis) at the right of every item -->
<mat-list class="margin-bottom-1" *ngIf="!isSelectingItems">
  <mat-list-item
    *ngFor="let row of dataRows"
    data-cy="mobile-list-item"
    class="mat-row"
    [class.disabled]="processingDictionary[row.id]"
    (click)="rowClick.emit(row)"
    (contextmenu)="emitRowOptionsButtonClick($event, row, true)"
  >
    <rav-icon
      matListIcon
      *ngIf="config.mobileSettings?.icon"
      class="dark-color"
      [name]="
        typeOf(config.mobileSettings?.icon) === 'string' ? config.mobileSettings.icon : config.mobileSettings.icon(row)
      "
    ></rav-icon>
    <img
      matListIcon
      *ngIf="config.mobileSettings?.subtitleAdditionalInfo && !config.mobileSettings?.icon"
      class="mobile-table__outbox-icon"
      src="assets/icons/{{ row[config.mobileSettings?.subtitleKey] }}-outbox.svg"
    />
    <h3
      matLine
      data-cy="mobile-table-item-title"
      *ngIf="renamingRowId !== row.id"
      [ngClass]="
        row.internal_link === null || !config.rowLaunchLink
          ? 'mobile-table__non-clickable-row-title'
          : 'mobile-table__clickable-row-title'
      "
    >
      {{ getRowTitle(row) }}
    </h3>
    <rav-editor
      matLine
      *ngIf="renamingRowId === row.id"
      [currentText]="row[config.mobileSettings.titleKeys[0]]"
      [editType]="row.type"
      [id]="row.id"
      [isMobileTable]="true"
      (editionEvent)="updateFileName($event)"
    ></rav-editor>
    <p matLine>
      {{ getRowSubtitle(row) }}
    </p>
    <rav-icon
      matListIcon
      data-cy="mobile-table-options"
      *ngIf="columnsToDisplay.includes('mobileAction')"
      [name]="RavIcon.EllipsisVertical"
      (click)="emitRowOptionsButtonClick($event, row)"
      class="mobile-table__options-icon order-10"
      [ngClass]="{ 'margin-left-1': renamingRowId === row.id }"
    ></rav-icon>
  </mat-list-item>
</mat-list>

<!-- Selection list that includes the same elements of the table above, but each element can be selected and the options button is replaced by a checkbox -->
<mat-selection-list class="margin-bottom-1" *ngIf="isSelectingItems">
  <mat-list-option
    *ngFor="let row of dataRows; let i = index"
    class="mat-row"
    color="primary"
    [disabled]="processingDictionary[row.id]"
    [class.disabled]="processingDictionary[row.id]"
    [class.mobile-table__selected-option]="isRowSelected(i)"
    [selected]="isRowSelected(i)"
    (click)="emitSelectionMade($event, i)"
  >
    <rav-icon
      matListIcon
      *ngIf="config.mobileSettings?.icon && !processingDictionary[row.id]"
      class="dark-color"
      [name]="
        typeOf(config.mobileSettings?.icon) === 'string' ? config.mobileSettings.icon : config.mobileSettings.icon(row)
      "
    >
    </rav-icon>
    <rav-loader matListIcon type="icon" *ngIf="processingDictionary[row.id]"> </rav-loader>

    <img
      matListIcon
      *ngIf="config.mobileSettings?.subtitleAdditionalInfo && !config.mobileSettings?.icon"
      class="mobile-table__outbox-icon"
      src="assets/icons/{{ row[config.mobileSettings?.subtitleKey] }}-outbox.svg"
    />
    <h3
      matLine
      [ngClass]="
        row.internal_link === null || !config.rowLaunchLink
          ? 'mobile-table__non-clickable-row-title'
          : 'mobile-table__clickable-row-title'
      "
    >
      {{ getRowTitle(row) }}
    </h3>
    <p matLine>
      {{ getRowSubtitle(row) }}
    </p>
  </mat-list-option>
</mat-selection-list>
